import { useAuth } from '@portals-platform/auth';
import { Button, Card, CardContent, CardHeader, CardTitle } from '@portals-platform/ui';
import { useNavigate, useSearch } from '@tanstack/react-router';
import { useEffect } from 'react';

export function LoginPage() {
  const { login, isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();
  const { returnTo } = useSearch({ from: '/login' });

  useEffect(() => {
    if (!isLoading && isAuthenticated) void navigate({ to: returnTo ?? '/' });
  }, [isAuthenticated, isLoading, navigate, returnTo]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--color-background)] p-4">
      <Card className="w-full max-w-sm">
        <CardHeader>
          <CardTitle className="text-center text-2xl">Certificate Portal</CardTitle>
        </CardHeader>
        <CardContent className="flex flex-col gap-4">
          <p className="text-center text-[var(--color-muted-foreground)] text-sm">
            Sign in to access your certificates
          </p>
          <Button onClick={() => login(returnTo)} className="w-full">
            Sign In
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
